import type BusStopState from "../store/schema/BusStopState";
import getListViewState from "../selectors/getListViewState";
export default function resetExpansionViewStateInternal(): void {
    const expansionState = getListViewState().expandedConversationViewState;
    
    // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
    // -> Error TS2322 (10,5): Type 'null' is not assignable to type 'string'.
    // @ts-expect-error
    expansionState.expandedRowKey = null;
    // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
    // -> Error TS2322 (14,5): Type 'null' is not assignable to type 'string'.
    // @ts-expect-error
    expansionState.focusedNodeId = null;
    expansionState.lastAutoFocusedNodeId = null;
    expansionState.anchorNodeId = null;
    // Skip resetting already-empty observable arrays to avoid triggering unnecessary MobX reactions
    if (!expansionState.selectedNodeIds || expansionState.selectedNodeIds.length > 0) {
        expansionState.selectedNodeIds = [];
    }
    if (!expansionState.allNodeIds || expansionState.allNodeIds.length > 0) {
        expansionState.allNodeIds = [];
    }
    expansionState.shouldBeExpanded = false;
    expansionState.busStopStateMap = new Map<string, BusStopState>([]);
    expansionState.forks = null;
}
